import { IPaginateElements, IPagination, IState } from '@/store/types/search.types';
import { TAppError, IBaseAction, IBaseState } from '@/store/types/base.state';
import {
  IWallet,
  TWalletTypeId,
  walletStatusList,
  IWalletAccountDetailsDownload,
  IWalletDomiciliationCertificateDownload,
  IWalletBalanceCertificateDownload,
  IWalletClosureCertficateDownload,
} from '@/features/wallets/store/models/wallet.model';
import {
  IButtonField,
  IPeriodField,
  ISearch,
  ISearchField,
  ISelectField,
  TPeriodBasesType,
} from '@/ui-kit/table-filters/filters.type';

export const agentWalletsActionTypes = {
  SEARCH_AGENT_WALLETS: 'AGENT_WALLETS.SEARCH_AGENT_WALLETS',
  SEARCH_AGENT_WALLETS_SUCCESS: 'AGENT_WALLETS.SEARCH_AGENT_WALLETS_SUCCESS',
  SEARCH_AGENT_WALLETS_FAIL: 'AGENT_WALLETS.SEARCH_AGENT_WALLETS_FAIL',
  GET_AGENT_WALLET_ACCOUNT_DETAILS: 'AGENT_WALLETS.GET_WALLET_ACCOUNT_DETAILS',
  GET_AGENT_WALLET_ACCOUNT_DETAILS_SUCCESS: 'AGENT_WALLETS.GET_WALLET_ACCOUNT_DETAILS_SUCCESS',
  GET_AGENT_WALLET_ACCOUNT_DETAILS_FAIL: 'AGENT_WALLETS.GET_WALLET_ACCOUNT_DETAILS_FAIL',
  GET_AGENT_WALLET_DOMICILIATION_CERTIFICATE: 'AGENT_WALLETS.GET_WALLET_DOMICILIATION_CERTIFICATE',
  GET_AGENT_WALLET_DOMICILIATION_CERTIFICATE_SUCCESS: 'AGENT_WALLETS.GET_WALLET_DOMICILIATION_CERTIFICATE_SUCCESS',
  GET_AGENT_WALLET_DOMICILIATION_CERTIFICATE_FAIL: 'AGENT_WALLETS.GET_WALLET_DOMICILIATION_CERTIFICATE_FAIL',
  GET_AGENT_WALLET_BALANCE_CERTIFICATE: 'AGENT_WALLETS.GET_WALLET_BALANCE_CERTIFICATE',
  GET_AGENT_WALLET_BALANCE_CERTIFICATE_SUCCESS: 'AGENT_WALLETS.GET_WALLET_BALANCE_CERTIFICATE_SUCCESS',
  GET_AGENT_WALLET_BALANCE_CERTIFICATE_FAIL: 'AGENT_WALLETS.GET_WALLET_BALANCE_CERTIFICATE_FAIL',
  GET_AGENT_WALLET_CLOSURE_CERTIFICATE: 'AGENT_WALLETS.GET_WALLET_CLOSURE_CERTIFICATE',
  GET_AGENT_WALLET_CLOSURE_CERTIFICATE_SUCCESS: 'AGENT_WALLETS.GET_WALLET_CLOSURE_CERTIFICATE_SUCCESS',
  GET_AGENT_WALLET_CLOSURE_CERTIFICATE_FAIL: 'AGENT_WALLETS.GET_WALLET_CLOSURE_CERTIFICATE_FAIL',
} as const;

export interface ISearchAgentWalletsAction extends IBaseAction {
  type: typeof agentWalletsActionTypes.SEARCH_AGENT_WALLETS;
}

export interface ISearchAgentWalletsSuccessAction extends IBaseAction {
  type: typeof agentWalletsActionTypes.SEARCH_AGENT_WALLETS_SUCCESS;
  wallets: IWallet[];
  pagination: IPagination;
}

export interface ISearchAgentWalletsFailAction extends IBaseAction {
  type: typeof agentWalletsActionTypes.SEARCH_AGENT_WALLETS_FAIL;
  error: TAppError;
}

export interface IGetAgentWalletAccountDetailsAction extends IBaseAction {
  type: typeof agentWalletsActionTypes.GET_AGENT_WALLET_ACCOUNT_DETAILS;
  walletId: number;
}

export interface IGetAgentWalletAccountDetailsSuccessAction extends IBaseAction {
  type: typeof agentWalletsActionTypes.GET_AGENT_WALLET_ACCOUNT_DETAILS_SUCCESS;
  walletId: number;
  walletAccountDetail: IWalletAccountDetailsDownload;
}

export interface IGetAgentWalletAccountDetailsFailAction extends IBaseAction {
  type: typeof agentWalletsActionTypes.GET_AGENT_WALLET_ACCOUNT_DETAILS_FAIL;
  walletId: number;
  error: TAppError;
}

export interface IGetAgentWalletDomiciliationCertificateAction extends IBaseAction {
  type: typeof agentWalletsActionTypes.GET_AGENT_WALLET_DOMICILIATION_CERTIFICATE;
  walletId: number;
}

export interface IGetAgentWalletDomiciliationCertificateSuccessAction extends IBaseAction {
  type: typeof agentWalletsActionTypes.GET_AGENT_WALLET_DOMICILIATION_CERTIFICATE_SUCCESS;
  walletId: number;
  domiciliationCertificate: IWalletDomiciliationCertificateDownload;
}

export interface IGetAgentWalletDomiciliationCertificateFailAction extends IBaseAction {
  type: typeof agentWalletsActionTypes.GET_AGENT_WALLET_DOMICILIATION_CERTIFICATE_FAIL;
  walletId: number;
  error: TAppError;
}

export interface IGetAgentWalletBalanceCertificateAction extends IBaseAction {
  type: typeof agentWalletsActionTypes.GET_AGENT_WALLET_BALANCE_CERTIFICATE;
  walletId: number;
}

export interface IGetAgentWalletBalanceCertificateSuccessAction extends IBaseAction {
  type: typeof agentWalletsActionTypes.GET_AGENT_WALLET_BALANCE_CERTIFICATE_SUCCESS;
  walletId: number;
  balanceCertificate: IWalletBalanceCertificateDownload;
}

export interface IGetAgentWalletBalanceCertificateFailAction extends IBaseAction {
  type: typeof agentWalletsActionTypes.GET_AGENT_WALLET_BALANCE_CERTIFICATE_FAIL;
  walletId: number;
  error: TAppError;
}

export interface IGetAgentWalletClosureCertificateAction extends IBaseAction {
  type: typeof agentWalletsActionTypes.GET_AGENT_WALLET_CLOSURE_CERTIFICATE;
  walletId: number;
}

export interface IGetAgentWalletClosureCertificateSuccessAction extends IBaseAction {
  type: typeof agentWalletsActionTypes.GET_AGENT_WALLET_CLOSURE_CERTIFICATE_SUCCESS;
  walletId: number;
  closureCertificate: IWalletClosureCertficateDownload;
}

export interface IGetAgentWalletClosureCertificateFailAction extends IBaseAction {
  type: typeof agentWalletsActionTypes.GET_AGENT_WALLET_CLOSURE_CERTIFICATE_FAIL;
  walletId: number;
  error: TAppError;
}

export type TAgentWalletsAction =
  | ISearchAgentWalletsAction
  | ISearchAgentWalletsSuccessAction
  | ISearchAgentWalletsFailAction
  | IGetAgentWalletAccountDetailsAction
  | IGetAgentWalletAccountDetailsSuccessAction
  | IGetAgentWalletAccountDetailsFailAction
  | IGetAgentWalletDomiciliationCertificateAction
  | IGetAgentWalletDomiciliationCertificateSuccessAction
  | IGetAgentWalletDomiciliationCertificateFailAction
  | IGetAgentWalletBalanceCertificateAction
  | IGetAgentWalletBalanceCertificateSuccessAction
  | IGetAgentWalletBalanceCertificateFailAction
  | IGetAgentWalletClosureCertificateAction
  | IGetAgentWalletClosureCertificateSuccessAction
  | IGetAgentWalletClosureCertificateFailAction;

export interface IAgentProfileWallet {
  wallet: IWallet;
  accountDetails?: IState<IWalletAccountDetailsDownload>;
  domiciliationCertificate?: IState<IWalletDomiciliationCertificateDownload>;
  balanceCertificate?: IState<IWalletBalanceCertificateDownload>;
  closureCertificate?: IState<IWalletClosureCertficateDownload>;
}

export interface IAgentWalletsState extends IBaseState {
  paginateWallets: IPaginateElements<IAgentProfileWallet>;
}

export interface IAllWalletsFiltersFormFields {
  typeId: TWalletTypeId;
  search?: ISearch;
  status?: keyof typeof walletStatusList;
  createdDate?: {
    from: string;
    to: string;
    base: TPeriodBasesType;
  };
}

export type TAllWalletsFiltersFields = {
  typeId: IButtonField<TWalletTypeId>;
  status: ISelectField;
  createdDate: IPeriodField;
  search: ISearchField;
};
